export const normalizeAttendanceText = (value) => String(value || '').trim();

export const attendanceMatchesPayload = (session, payload, entryIdField = 'studentId') => {
  if (!session || !payload) return false;
  if (payload.id && Number(session.id) !== Number(payload.id)) return false;
  if (String(session.date || '') !== String(payload.date || '')) return false;
  if (String(session.classId || '') !== String(payload.classId || '')) return false;
  if (normalizeAttendanceText(session.lessonTheme) !== normalizeAttendanceText(payload.lessonTheme)) return false;
  if (normalizeAttendanceText(session.objective) !== normalizeAttendanceText(payload.objective)) return false;
  if (normalizeAttendanceText(session.notes) !== normalizeAttendanceText(payload.notes)) return false;

  const expected = Array.isArray(payload.entries) ? payload.entries : [];
  const actual = Array.isArray(session.entries) ? session.entries : [];
  if (expected.length !== actual.length) return false;

  const actualByPerson = new Map(actual.map((entry) => [String(entry?.[entryIdField]), entry]));
  return expected.every((entry) => {
    const saved = actualByPerson.get(String(entry?.[entryIdField]));
    if (!saved) return false;
    const automaticallyJustified = saved.status === 'JUSTIFIED'
      && Boolean(saved.absenceJustificationId);
    const statusMatches = String(saved.status || '') === String(entry.status || '')
      || automaticallyJustified;
    const notesMatch = normalizeAttendanceText(saved.notes) === normalizeAttendanceText(entry.notes)
      || (automaticallyJustified && !normalizeAttendanceText(entry.notes)
        && normalizeAttendanceText(saved.notes).startsWith('Justificado automaticamente:'));
    return statusMatches && notesMatch;
  });
};

const ATTENDANCE_TRANSIENT_STATUS = new Set([502, 503, 504]);
const attendanceWait = (milliseconds) =>
  new Promise((resolve) => setTimeout(resolve, milliseconds));

const isTransientAttendanceSaveError = (error) => {
  const status = Number(error?.response?.status || 0);
  if (ATTENDANCE_TRANSIENT_STATUS.has(status)) return true;
  if (error?.response) return false;
  return ['ERR_NETWORK', 'ECONNABORTED', 'ETIMEDOUT'].includes(
    String(error?.code || '')
  );
};

export const saveAttendanceWithRecovery = async ({
  api,
  endpoint,
  payload,
  entryIdField = 'studentId',
  attempts = 5,
}) => {
  let lastError = null;

  const findPersistedAttendance = async () => {
    try {
      const response = await api.get(endpoint, {
        params: {
          date: payload?.date || undefined,
          classId: payload?.classId || undefined,
        },
        skipGlobalErrorModal: true,
        skipTransientRetry: true,
      });
      const sessions = Array.isArray(response.data) ? response.data : [];
      return sessions.find((session) =>
        attendanceMatchesPayload(session, payload, entryIdField)
      ) || null;
    } catch (_) {
      return null;
    }
  };

  try {
    const response = await api.post(endpoint, payload, {
      skipGlobalErrorModal: true,
    });
    return response.data;
  } catch (error) {
    if (!isTransientAttendanceSaveError(error)) throw error;
    lastError = error;
  }

  // Uma resposta perdida não informa se houve gravação. Apenas consultar:
  // reenviar o POST pode duplicar chamadas que ainda estão sendo concluídas.
  for (let attempt = 0; attempt < attempts; attempt += 1) {
    await attendanceWait(Math.min(450 * (attempt + 1), 1800));
    const persisted = await findPersistedAttendance();
    if (persisted) return persisted;
  }
  throw lastError;
};
